import Button from '../../Button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogDetails,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger
} from '../../dialogs/BaseDialog';

type AlertDialogProps = {
  children: React.ReactNode;
  title?: string;
  description?: string;
  confirmText?: string;
  onConfirm?: () => void;
  cancelText?: string;
  onCancel?: () => void;
  renderTrigger?: () => React.ReactNode;
  contentProps?: React.ComponentPropsWithoutRef<typeof DialogContent>;
  detailsProps?: React.ComponentPropsWithoutRef<typeof DialogContent>;
  portalContainer?: HTMLElement | null;
  showCloseIcon?: boolean;
} & React.ComponentPropsWithoutRef<typeof Dialog>;

export default function AlertDialog({
  children,
  title = 'Alert',
  description,
  confirmText = 'OK',
  onConfirm,
  cancelText,
  onCancel,
  renderTrigger,
  contentProps,
  detailsProps,
  portalContainer,
  showCloseIcon = true,
  ...props
}: AlertDialogProps) {
  return (
    <Dialog {...props}>
      {!!renderTrigger && (
        <DialogTrigger asChild>{renderTrigger()}</DialogTrigger>
      )}
      <DialogContent
        {...contentProps}
        portalContainer={portalContainer}
        showCloseIcon={showCloseIcon}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {!!description && (
            <DialogDescription>{description}</DialogDescription>
          )}
        </DialogHeader>
        <DialogDetails {...detailsProps}>{children}</DialogDetails>
        <DialogFooter>
          {cancelText &&
            (onCancel ? (
              <Button size="small" onClick={onCancel} type="submit">
                {cancelText}
              </Button>
            ) : (
              <DialogClose asChild>
                <Button size="small" type="submit">
                  {cancelText}
                </Button>
              </DialogClose>
            ))}
          {confirmText &&
            (onConfirm ? (
              <Button size="small" onClick={onConfirm} type="submit">
                {confirmText}
              </Button>
            ) : (
              <DialogClose asChild>
                <Button size="small" type="submit">
                  {confirmText}
                </Button>
              </DialogClose>
            ))}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
